import React, { useState, useEffect, useCallback } from "react";
import { processService } from "../../services/process.service";
import { toast } from "sonner";
import { AdminProcessList as ProcessList } from "../management/AdminProcessList";
import { ProcessDetail } from "../management/ProcessDetail";
import { SindicatoViewsManager } from "../management/SindicatoViewsManager";

const { getProcessos } = processService;

const SECTIONS = [
  { key: "processos", label: "Processos" },
  { key: "sindicato", label: "Painel Sindicato" },
];

export function ManagementView({ onBack }) {
  const [section, setSection] = useState("processos");
  const [processos, setProcessos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProcesso, setSelectedProcesso] = useState(null);

  const fetchProcessos = useCallback(async () => {
    try {
      if (processos.length === 0) setLoading(true);

      const data = await getProcessos();
      setProcessos(data);

      if (selectedProcesso) {
        const updated = data.find(p => p.id === selectedProcesso.id);
        if (updated && JSON.stringify(updated) !== JSON.stringify(selectedProcesso)) {
          setSelectedProcesso(updated);
        }
      }
    } catch (e) {
      toast.error("Erro ao carregar processos");
    } finally {
      setLoading(false);
    }
  }, [processos.length, selectedProcesso]);

  useEffect(() => {
    fetchProcessos();
  }, [fetchProcessos]);

  if (selectedProcesso) {
    return (
      <ProcessDetail
        processo={selectedProcesso}
        onBack={() => setSelectedProcesso(null)}
        onRefresh={fetchProcessos}
      />
    );
  }

  return (
    <div className="p-4 md:p-8 w-full">
      <div className="max-w-6xl mx-auto space-y-6">
        {/* Section switcher */}
        <div className="border-b border-slate-200 flex gap-1">
          {SECTIONS.map((s) => (
            <button
              key={s.key}
              onClick={() => setSection(s.key)}
              className={`px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px ${
                section === s.key
                  ? "border-slate-800 text-slate-800"
                  : "border-transparent text-slate-500 hover:text-slate-700"
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>

        {section === "processos" && (
          <ProcessList
            processos={processos}
            loading={loading}
            onSelectProcess={setSelectedProcesso}
            onRefresh={fetchProcessos}
            onBack={onBack}
          />
        )}

        {section === "sindicato" && <SindicatoViewsManager />}
      </div>
    </div>
  );
}
